// src/config/step1.js
import { Step1QuestionIdConstants } from "../constants/textconstants";
import { getBibhags } from "../helper-functions";

// Import your translation keys, possibly from a common constants file
// Or directly use string literals that match your JSON keys.
// For clarity, I'm using string literals matching the keys in en.json/bn.json

export const config1 = [
  {
    fieldName: "SHOP_NAME", 
    isOptional: false,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_5,
    placeholder: "SHOP_NAME_PLACEHOLDER", 
  },
  {
    fieldName: "CONTACT_PERSON_NAME", 
    isOptional: false,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_1,
    placeholder: "ENTER_NAME", 
  },
   {
    fieldName: "TYPE_OF_ESTABLISHMENT", 
    isOptional: false,
    type: "singleSelect",
    identifier: Step1QuestionIdConstants.QUESTION_6,
    placeholder: "SELECT_ESTABLISHMENT_TYPE", 
    options: [
      { id: 1, value: "PROPRIETORSHIP" }, 
      { id: 2, value: "PARTNERSHIP" },    
      { id: 3, value: "COMPANY" },        
    ],
  },
  {
    fieldName: "SELL_BAYER_PRODUCTS", 
    isOptional: false,
    type: "radio",
    identifier: Step1QuestionIdConstants.QUESTION_7,
    placeholder: "SELECT", 
    options: [
      { id: 1, value: "YES" }, 
      { id: 2, value: "NO" },  
    ],
  },
  {
    fieldName: "CUSTOMER_TYPE", 
    isOptional: false,
    type: "singleSelect",
    identifier: Step1QuestionIdConstants.QUESTION_8,
    placeholder: "CUSTOMER_TYPE", 
    options: [
      { id: 1, value: "DISTRIBUTOR" },
      { id: 2, value: "RETAILER" },
      { id: 3, value: "BLF" },
      { id: 4, value: "STARTUP_OUTLET" },
    ],
  },
  {
    fieldName: "MOBILE_NUMBER", 
    isOptional: false,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_2,
    placeholder: "MOBILE_NUMBER", 
  },
  {
    fieldName: "EMAIL_ADDRESS", 
    isOptional: true,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_3,
    placeholder: "ENTER_VALID_EMAIL", 
  },


   {
    fieldName: "BAZAAR_NAME", 
    isOptional: true,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_26,
    placeholder: "BAZAAR_NAME", 
  },



  {
    fieldName: "AGE", 
    isOptional: false,
    type: "singleSelect",
    identifier: Step1QuestionIdConstants.QUESTION_4,
    placeholder: "AGE_PLACEHOLDER", 
    options:[
      { id: 1, value: "LESS_THAN_20_YEARS" },
      { id: 2, value: "BETWEEN_20_30_YEARS" },
      { id: 3, value: "BETWEEN_31_40_YEARS" },
      { id: 4, value: "BETWEEN_41_50_YEARS" },
      { id: 5, value: "BETWEEN_51_60_YEARS" }, 
      { id: 6, value: "MORE_THAN_60_YEARS" },
    ],
  },
  
 
  
  {
    fieldName: "BIBHAG", 
    isOptional: false,
    type: "singleSelect",
    identifier: Step1QuestionIdConstants.QUESTION_9,
    placeholder: "SELECT", 
    options: await getBibhags(),
  },
  {
    fieldName: "DISTRICT", 
    isOptional: false,
    type: "singleSelect",
    identifier: Step1QuestionIdConstants.QUESTION_10,
    placeholder: "SELECT", 
    options: [],
    isHalf: true,
    isFirst: true,
  },
  {
    fieldName: "SUB_DISTRICT", 
    isOptional: false,
    type: "singleSelect",
    identifier: Step1QuestionIdConstants.QUESTION_11,
    placeholder: "SELECT", 
    options: [],
    isHalf: true,
    isFirst: false,
  },
 
  {
    fieldName: "TERRITORY", 
    isOptional: true,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_15,
    placeholder: "TERRITORY", 
    options: [],
    isHalf: false,
    isFirst: true,
  },
 
  {
    fieldName: "YEARS_IN_PESTICIDES_BUSINESS", 
    isOptional: false,
    type: "singleSelect",
    identifier: Step1QuestionIdConstants.QUESTION_19,
    placeholder: "SELECT", 
    options: [
      { id: 1, value: "LESS_THAN_5_YEARS" },
      { id: 2, value: "BETWEEN_5_10_YEARS" },
      { id: 3, value: "BETWEEN_11_15_YEARS" },
      { id: 4, value: "BETWEEN_16_20_YEARS" },
      { id: 5, value: "BETWEEN_21_25_YEARS" }, 
      { id: 6, value: "MORE_THAN_25_YEARS" },
    ],
  },

  {
    fieldName: "ARE_YOU_FARMER", 
    isOptional: false,
    type: "radio",
    identifier: Step1QuestionIdConstants.QUESTION_20,
    placeholder: "SELECT", 
    options: [
      { id: 1, value: "YES" },
      { id: 2, value: "NO" },
    ],
  },
{
    fieldName: "ARE_YOU_AGRI_GRADUATE", 
    isOptional: false,
    type: "radio",
    identifier: Step1QuestionIdConstants.QUESTION_21,
    placeholder: "SELECT", 
    options: [
      { id: 1, value: "Below SSC" },
      { id: 2, value: "SSC" },
      { id: 3, value: "HSC" },
      { id: 4, value: "Graduate/Masters" },
      { id: 5, value: "Agri Graduate" },
    ],
  },



  {
    fieldName: "PIN_CODE", 
    isOptional: false,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_17,
    placeholder: "ENTER_6_DIGIT_PIN", 
  },
 
  
  
  
  {
    fieldName: "HAVE_LICENSE_PESTICIDES", 
    isOptional: false,
    type: "radio",
    identifier: Step1QuestionIdConstants.QUESTION_22,
    placeholder: "SELECT", 
    options: [
      { id: 1, value: "YES" },
      { id: 2, value: "NO" },
    ],
  },
  {
    fieldName: "HAVE_LICENSE_SEEDS",
    isOptional: false,
    type: "radio",
    identifier: Step1QuestionIdConstants.QUESTION_23,
    placeholder: "SELECT", 
    options: [
      { id: 1, value: "YES" },
      { id: 2, value: "NO" },
    ],
  },
  {
    fieldName: "HAVE_LICENSE_FERTILIZERS",
    isOptional: false,
    type: "radio",
    identifier: Step1QuestionIdConstants.QUESTION_24,
    placeholder: "SELECT", 
    options: [
      { id: 1, value: "YES" },
      { id: 2, value: "NO" },
    ],
  },

   {
    fieldName: "OTHER_BUSINESS", 
    isOptional: true,
    type: "text",
    identifier: Step1QuestionIdConstants.QUESTION_25,
    placeholder: "OTHER_BUSINESS", 
  },
];